import React, { Component } from 'react'
import * as PropTypes from "prop-types";

import { Form, Modal, Radio, Row, Col, Progress } from "antd";
import { DatePickerWithMask } from '../../../../components';

import moment from 'moment';

import { employeesContractsService, recalculateSchedulesService, timeBankMaintenanceService } from '../../../../redux/services';

const formId = `form-drawer-${Math.floor(Math.random() * 10001)}`;

class Recalculate extends Component {
  static propTypes = {
		visible: PropTypes.bool.isRequired,
		onComplete: PropTypes.func.isRequired,
		onClose: PropTypes.func.isRequired,
    data: PropTypes.array.isRequired,
	};

  constructor(props) {
		super(props);

		this.state = {
      isSending: false,
      recalcular: true,
      progress: 0,
      contract_id: 0
    };
	}

  onOpen = (uuid) => {
    employeesContractsService.show({ uuid })
      .then((response) => {
        const item = response.data.data;

        this.setState({
          contract_id: item.id,
        })
      })
      .catch((data) => {
				Modal.error({
					title: "Ocorreu um erro!",
					content: String(data),
					onOk: () => {
						// Force close
						return this.onClose();
					}
				});
			});
  };

  onClose = () => {
		// Callback
		this.props.onComplete();
	};

  onFinish = async () => {
    this.startProgress();

    try {
      this.setState({
        isSending: true,
      });
  
      const values = await this.form.validateFields();
      const data = { ...values };

      const { contract_id, recalcular } = this.state;
      const { data: dados } = this.props;
  
      let contractNewData = {};

      try {
        const { data: contractData } = await employeesContractsService.edit(dados);
        contractNewData = contractData.data;

        this.setState({
          isLoading: false,
          isSending: false,
        });

      } catch (error) {
        this.setState({
          isSending: false,
        });
        Modal.error({
          title: "Ocorreu um erro!",
          content: String(error),
        });
        return;
      }
  
      // if (recalcular) {
      this.setState({
        isSending: true,
      });

      data.data_inicial = recalcular
        ? moment(data.data_inicial).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD');
      data.data_final = recalcular
        ? moment(data.data_final).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD');
      data.contrato = contract_id;
      data.manter_jornada_original = true;

      if (contractNewData.nao_usa_banco_horas && dados.cleanedHours) {
        await timeBankMaintenanceService.create({
          acao: "limpar_ajuste",
          data: moment().subtract(1, 'day').format('YYYY-MM-DD'),
          empresas: [dados.empresa_id],
          funcionarios: [dados.funcionario_id],
          status: true,
        });

        await timeBankMaintenanceService.create({
          acao: "fechar_banco_hora",
          data: moment(data.data_inicial).subtract(1, 'day').format('YYYY-MM-DD'),
          empresas: [dados.empresa_id],
          funcionarios: [dados.funcionario_id],
          status: true,
        })
      }
        
      if (data.data_inicial && data.data_final) {
        const response = await recalculateSchedulesService.recalculate(data);
        if (response.data === 'Concluído com sucesso!') {
          this.setState({
            isSending: false,
          });
          this.props.onComplete();
        }
      } else {
        this.setState({
          isSending: false,
        });
        this.props.onClose();
      }
    } catch (error) {
      this.setState({
        isSending: false,
      });
      
      const errorData = error?.errorFields[0]?.errors[0] || error;

      Modal.error({
        title: "Ocorreu um erro!",
        content: String(errorData),
      });
    }
  };

  startProgress = () => {
    let steps = [5, 10, 15, 25, 30, 40, 50, 75, 90, 99];
    let index = 0;

    this.setState({ progress: 0, isSending: true });

    this.progressInterval = setInterval(() => {
      if (index < steps.length) {
        this.setState({ progress: steps[index] });
        index++;
      } else {
        clearInterval(this.progressInterval);
      }
    }, 5000);
  };  

  validateEndDate = async (_, value) => {
    if (value && (typeof value === 'string' || !value.isValid())) {
      return Promise.reject(new Error('Data inválida.'));
    }
    const dataInicial = this.form.getFieldValue('data_inicial');
    if (!value || !dataInicial || value.endOf('day').isSameOrAfter(dataInicial)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Data final deve ser maior ou igual à data inicial.'));
  };

  validateStartDate = async (_, value) => {
    if (value && (typeof value === 'string' || !value.isValid())) {
      return Promise.reject(new Error('Data inválida.'));
    }
    const dataFinal = this.form.getFieldValue('data_final');
    if (!value || !dataFinal || value.startOf('day').isSameOrBefore(dataFinal)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('Data inicial deve ser maior ou igual à data final.'));
  };

  render() {
    const { visible } = this.props;

    const { isSending } = this.state;

    return (
      <Modal
        visible={visible}
        title="Recalcular Horários"
        keyboard={false}
        centered
        destroyOnClose={true}
        maskClosable={false}
        closable={false}
        width={500}
        okText={this.state.recalcular ? "Recalcular" : "Finalizar"}
        onOk={this.onFinish}
        confirmLoading={isSending}
        cancelButtonProps={{ disabled: isSending }}
        onCancel={() => this.props.onCancel?.()}
        className="modal-recalcular"
      >
        <Form
          ref={el => this.form = el}
          id={formId}
          layout="vertical"
          scrollToFirstError
          onFinish={this.onFinish}
          initialValues={{}}
        >
          <p>
            Atenção: A modificação que você fez aqui pode alterar cálculos de
            horas de dias anteriores. O que deseja fazer?
          </p>
          <Radio
            checked={this.state.recalcular}
            onChange={() => this.setState({ recalcular: true })}
          >
            Recalcular marcações de dias anteriores.
          </Radio>
          <Row gutter={16}>
            <Col xs={12}>
              <DatePickerWithMask
                name="data_inicial"
                label="Data Início"
                rules={[
                  { required: this.state.recalcular, message: 'Campo obrigatório.' },
                  { validator: this.validateStartDate }
                ]}
              />
            </Col>
            <Col xs={12}>
              <DatePickerWithMask
                name="data_final"
                label="Data Fim"
                rules={[
                  { required: this.state.recalcular, message: 'Campo obrigatório.' },
                  { validator: this.validateEndDate }
                ]}
              />
            </Col>
          </Row>
          <Radio
            checked={!this.state.recalcular}
            onChange={() => this.setState({ 
              recalcular: false,
              data_inicial: moment().format('YYYY-MM-DD'),
              data_final: moment().format('YYYY-MM-DD'),
             })}
          >
            Aplicar esta modificação somente para as novas marcações.
          </Radio>
          {isSending && <Progress percent={this.state.progress} />}
        </Form>
      </Modal>
    )
  }
}

export default Recalculate;
